/**
 * The one place `brotli` is imported, and lazily: its decoder and dictionary are about 50 kB gzipped,
 * and only a `.woff2` scene font needs them. `brotliImportSite.contract.test.ts` holds the import to
 * this file. The decoder is pure JS, as the webview CSP blocks WASM and `DecompressionStream` has no
 * brotli format.
 */
import { memoisedImport } from '../../../../resources/memoisedImport';
/** The Brotli decoder, one import shared by every caller. */
export const loadBrotliDecoder = memoisedImport(() => import('brotli/decompress').then((m) => m.decompress));
//# sourceMappingURL=brotliDecoder.js.map